import { type BlockViewProps } from '@plone/types';
import type { BCDescriptionTitleData } from './schema';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterDescription/bcdescription.scss';
import RelatedProducts from './relatedproducts';

type Props = Omit<BlockViewProps, 'data'> & {
  data: BCDescriptionTitleData;
};

const BCDescriptionBlockView = (props: Props) => {
  const { data, properties } = props;
  // @ts-expect-error
  const { bowling_center_products = [] } = properties;
  return (
    <div className="description-container">
      <div className="description-wrapper left">
        <div className="documentDescription">
          {properties['description'] || ''}
        </div>
      </div>
      <div className="text-wrapper right">
        <div className="text">
          <TextBlockView data={{ value: data.text ?? {} }} />
        </div>
        {data.linkHref?.[0] && (
          <CTA
            href={data.linkHref[0]['@id']}
            openLinkInNewTab={false}
            ctaButtonStyle={data.ctaButtonStyle}
            linkIcon={data.linkIcon}
            cta_color={data.cta_color}
          >
            {data.linkTitle}
          </CTA>
        )}
      </div>
      <div className="clear-inline-start"></div>
      {/* fix in case the related products are deleted from the website */}
      {bowling_center_products.length > 0 && !!bowling_center_products[0] && (
        <RelatedProducts items={bowling_center_products} isEditMode={false} />
      )}
      <div className="clear"></div>
    </div>
  );
};

export default BCDescriptionBlockView;
